import './userSpecificInfo.scss';

import React from 'react';
import classnames from 'classnames';
import { withLocalize, Translate } from 'react-localize-redux';
import BbInput from '../styling/bbInput';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiGet, apiPut, getHostApi } from '../../store/apiWrapper';
import Message from '../common/message';
import BbCheckbox from '../styling/bbFormikCheckbox';
import { userContextActions } from '../../store/userContextStore';
import { Circles } from '../common/loadingComponent';

class UserSpecificInfo extends React.Component {
    mounted = true;

    constructor(props) {
        super(props)

        this.state = {
            error: null,
            isLoading: false,
            userInfo: {
                username: this.props.authentication.profile.username || '',
                email: this.props.authentication.profile.email || '',
                name: this.props.authentication.profile.name || '',
                surname: this.props.authentication.profile.surname || '',
                registrationDate: '',
                expirationDate: '',
                passwordExpirationDate: '',
                isActive: false,
                language: null
            }
        };
    }

    componentDidMount() {
        this.setState({ error: null, isLoading: true });
        apiGet(`${getHostApi()}/api/account/user`, null,
            res => {
                if (!this.mounted) {
                    return;
                }
                const language = this.props.languages.find(lang => lang.code === res.data.languageCode) || this.props.languages[0];
                this.setState(state => ({
                    userInfo: {
                        ...state.userInfo,
                        ...{
                            registrationDate: res.data.registrationDateFormated,
                            expirationDate: res.data.expirationDateFormated,
                            passwordExpirationDate: res.data.passwordExpirationDateFormated,
                            isActive: res.data.isActive,
                            language: { label: language.name, value: language.code }
                        }
                    }
                }));
            },
            _ => this.mounted && this.setState({ error: this.props.translate('Common.Error') }),
            _ => this.mounted && this.setState({ isLoading: false })
        );
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <>
                <div className='card card-special'>
                    <div className='card-body'>
                        {this.state.isLoading ? <Circles /> : <>
                            {this.state.error && <><Message type='error' message={this.state.error} /><br /></>}
                            <Formik
                                enableReinitialize
                                initialValues={this.state.userInfo}
                                onSubmit={values => this.submitValues(values)}
                                render={({ values, setFieldValue }) => (
                                    <Form>
                                        <BbInput type='text' name='username' label={this.props.translate('Common.User')} placeholder={{ type: 'column' }} disabled />
                                        <BbInput type='text' name='name' label={this.props.translate('Search.Common.FirstName')} placeholder={{ type: 'column' }} />
                                        <BbInput type='text' name='surname' label={this.props.translate('Common.Surname')} placeholder={{ type: 'column' }} />
                                        <BbInput type='text' name='email' label={this.props.translate('Search.Common.Mail')} placeholder={{ type: 'column' }} />
                                        <BbInput type='select-noformik' label={this.props.translate('User.UserInfo.EmailLanguage')} placeholder={{ type: 'column' }}
                                            name='language' className='field' value={values.language}
                                            options={this.props.languages.map(lang => ({ label: lang.name, value: lang.code }))}
                                            onChange={e => setFieldValue('language', e)} />
                                        <BbInput type='text' name='registrationDate' label={this.props.translate('User.UserInfo.RegistrationDate')} placeholder={{ type: 'column' }} disabled />
                                        <BbInput type='text' name='expirationDate' label={this.props.translate('User.UserInfo.ExpirationDate')} placeholder={{ type: 'column' }} disabled />
                                        <BbInput
                                            type='text' name='passwordExpirationDate'
                                            label={this.props.translate('User.UserInfo.PasswordExpirationDate')} placeholder={{ type: 'column' }} disabled />
                                        <div className="field bb-field user-specific-info">
                                            <div className="columns">
                                                <div className="column is-4" />
                                                <div className="column">
                                                    <BbCheckbox id='isActive' name='isActive' label={this.props.translate('Common.Active')} disabled />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='column is-narrow text-align-center'>
                                            <button className={classnames('bb-button is-primary gradient-1 bold-bb-button', { 'is-square': localStorage.locales_button_style === 'square' })} type='submit'>
                                                <Translate id='Common.Save' />
                                            </button>
                                        </div>
                                    </Form>
                                )} />
                        </>}
                    </div>
                </div>
            </>)
    }

    submitValues = values => {
        if (this.state.error || this.state.isLoading === true) {
            return;
        }
        this.setState({ error: null, isLoading: true });
        apiPut(`${getHostApi()}/api/account/user`, null,
            {
                name: values.name,
                surname: values.surname,
                email: values.email,
                language: values.language.value
            },
            _ => {
                if (!this.mounted) {
                    return;
                }
                this.setState({ isLoading: false });
                this.props.updateUserInfo({
                    name: values.name,
                    surname: values.surname,
                    email: values.email
                });
            },
            _ => this.mounted && this.setState({ error: this.props.translate('Common.Error'), isLoading: false })
        );
    }
}

export default withLocalize(connect(
    state => state.userContext,
    dispatch => bindActionCreators(userContextActions, dispatch)
)(UserSpecificInfo));